import { shape, string } from "prop-types"

export const ClassificationShape = shape({
    classificationId: string.isRequired,
    name: string.isRequired,
    description: string
})